export const MILESTONE_ROADMAP_POPPER_ID = 'milestone-roadmap-popper';

export const EMPTY_DOCUMENTS = [];
